<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <div class="page-title">回報問題列表</div>
        </el-col>
      </el-row>
      <div class="page-box">
        <div class="page-box-content">
          <div class="page-box-content-row">
            <div>
              <div class="search-text">回報日期和時間</div>
              <el-date-picker
                v-model="formLabelAlign.createdAt"
                type="date"
                placeholder="請輸入回報日期和時間"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </div>
            <div>
              <div class="search-text">回報人</div>
              <el-input
                v-model="formLabelAlign.studentNameLike"
                placeholder="請輸入回報人"
              ></el-input>
            </div>
            <div>
              <div class="search-text">題目編號</div>
              <el-input
                v-model="formLabelAlign.questionNoLike"
                placeholder="請輸入題目編號"
              ></el-input>
            </div>
            <div>
              <div class="search-text">題目類型</div>
              <el-select
                v-model="formLabelAlign.questionDisplayType"
                clearable
                placeholder="全部"
              >
                <el-option
                  v-for="(item, index) in questionTypes"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="search-text">狀態</div>
              <el-select
                  v-model="formLabelAlign.state"
                  clearable
                  placeholder="全部"
              >
                <el-option label="待處理" value="0"></el-option>
                <el-option label="已處理" value="1"></el-option>
              </el-select>
            </div>
            <div>
              <el-button type="info" class="button-el-el" @click.native="onSearch"
                >搜尋</el-button
              >
            </div>
            <div>
              <el-button
                type="success"
                class="button-el-el"
                @click.native="onReset"
                >清除篩選</el-button
              >
            </div>
          </div>
        </div>
        <el-table
          @sort-change="handleSortChange"
          :data="newTableData"
          style="width: 100%;"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column
            prop="createdAt"
            label="回報日期和時間"
            align="center"
          >
            <template slot-scope="{ row }">
              <span>{{ row.createdAt | formatDateTime }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="user.name" label="回報人" align="center">
            <template slot-scope="{ row }">
              <span v-if="row.user">{{ row.user.userNo }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="question.questionNo"
            label="題目編號"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.question">{{ row.question.questionNo }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="question.type"
            label="題目類型"
            align="center"
            sortable="custom"
          >
            <template slot-scope="{ row }">
              <span v-if="row.question">{{ row.question.type | questions }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="user.grade.name"
            label="年级"
            align="center"
            sortable="custom"
          >
        
          </el-table-column>
          <el-table-column
              prop="state"
              label="狀態"
              align="center"
              sortable="custom"
          >
            <template slot-scope="{ row }">
              <span :style="row.state===1 ? 'color: red;' : ''">{{ row.state===0?'待處理':'已處理'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="medium"
                @click="onDetailButton(row.id)"
                >詳情</el-button
              >

              <el-button
                  type="text"
                  size="medium"
                  @click="onUpdateState(row.id,1)"
              >處理</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <Pagination
      v-show="total > 0"
      :total="total"
      :page.sync="formLabelAlign._page"
      :limit.sync="formLabelAlign._limit"
      @pagination="getQuestionFeedbacks"
    />
    <deleteDialog
      titleCh="您確定要將此訂單價格更改為0嗎? <br />該訂單狀態將改為已支付"
      :centerDialogVisible="centerDialogVisible"
      @confirmFunction="confirmFunction"
      @onCancelButton="onCancelButton"
    ></deleteDialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { payStatus } from "@/biz/static-data";
import { getQuestionFeedbacks,updateState } from "@/api/setting";
import deleteDialog from "@/components/deleteDialog";
export default {
  components: { deleteDialog, Pagination },
  data() {
    return {
      sortingType:'',
      total: 0,
      payStatus: [],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      questionTypes: [
        { label: "全部", value: null },
        { label: "選擇題", value: 0 },
        { label: "判斷題", value: 1 },
        { label: "填空題", value: 2 },
        { label: "算術題(定數)", value: 3 },
        { label: "熱點圖", value: 4 },
        { label: "文字拖拽", value: 5 },
        { label: "連線題", value: 6 },
        { label: "拖拽題", value: 7 },
        { label: "算術題(變數)", value: 8 },
        { label: "文字拖拽(分類)", value: 9 },
      ],
      formLabelAlign: {
        studentNameLike: null,
        orderNoLike: null,
        createdAt: null,
        userNo: null,
        status: null,
        state: null,
        questionDisplayType: null,
        _page: 1,
        _limit: 50,
      },
      tableData: [],
    };
  },
  created() {
    this.payStatus = payStatus;
    this.getQuestionFeedbacks();
  },
  computed:{
    newTableData(){
      return  this.tableData
    }
  },
  methods: {
    handleSortChange(column) {
      const fieldName = column.prop
      this.sortingType = column.order
      const fieldNameList = fieldName.split('.')
      if (this.sortingType == 'ascending') {
        // 正序
        if(fieldNameList.length == 3){
          this.newTableData.sort((a, b) => a[fieldNameList[0]][fieldNameList[1]][fieldNameList[2]] - b[fieldNameList[0]][fieldNameList[1]][fieldNameList[2]])
        }else {
          this.newTableData.sort((a, b) => a[fieldNameList[0]][fieldNameList[1]] - b[fieldNameList[0]][fieldNameList[1]])
        }
        
      } else if (this.sortingType == 'descending') {
        // 倒序
         if(fieldNameList.length == 3){
          this.newTableData.sort((a, b) => b[fieldNameList[0]][fieldNameList[1]][fieldNameList[2]] - a[fieldNameList[0]][fieldNameList[1]][fieldNameList[2]])
        }else {
          this.newTableData.sort((a, b) => b[fieldNameList[0]][fieldNameList[1]] - a[fieldNameList[0]][fieldNameList[1]])
        }
      }
    },
    onUserNoText(id) {
      this.$router.push({ path: `/user/${id}` });
    },
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key == '_page'){
          this.formLabelAlign[key] = 1
        }
        if(key == '_limit'){
          this.formLabelAlign[key] = 50
        }
      })
      this.getQuestionFeedbacks();
    },
    onSearch() {
      this.getQuestionFeedbacks();
    },
    onCancelButton() {
      this.centerDialogVisible = false;
    },
    confirmFunction() {},

    onEditButton(id) {
      this.$router.push({ path: `/returnProblem/${id}/edit` });
    },
    onDetailButton(id) {
      let path = `/returnProblem/${id}`
      this.resolveRouter(path)
    },
    onUpdateState(id,state) {
      let formLabelAlign = {
        id: id,
        state: state
      };
      updateState(formLabelAlign);
      this.getQuestionFeedbacks();
    },
    onAlterButton(id) {
      this.orderId = id;
      this.centerDialogVisible = true;
    },
    getQuestionFeedbacks() {
      let formLabelAlign = {
        createdAt: this.formLabelAlign.createdAt,
        studentNameLike: this.formLabelAlign.studentNameLike,
        questionNoLike: this.formLabelAlign.questionNoLike,
        state: this.formLabelAlign.state,
        questionDisplayType: this.formLabelAlign.questionDisplayType,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      getQuestionFeedbacks(formLabelAlign).then((v) => {
        this.tableData = v.data;
        this.total = Number(v.headers["x-total-count"]);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      padding: 20px;
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
}
.button-el-el {
  width: 100%;
  margin-top: 23px;
}
.page-box-content{
  width: 100%;
  overflow-x: auto;
}
.page-box-content-row {
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, 220px);
    grid-template-rows: repeat(1, 1fr);
    gap: 8px;
    align-items: end;
}
.page-box-content-row>div:nth-last-child(1), .page-box-content-row>div:nth-last-child(2){
  width: 170px !important;
}
</style>